import { useCallback } from 'react';
import { useCommercialOfferDeleteItemMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const { handleError, handleSuccess } = useNotificationMessages();

  const [itemDelete, { isLoading }] = useCommercialOfferDeleteItemMutation();

  const onRemoveConfirm = useCallback(
    async (removeData: Record<string, any> | undefined) => {
      if (removeData) {
        try {
          const { data, error } = await itemDelete(removeData);
          if (data?.success) {
            handleSuccess('Commercial Offer Item was successfully deleted.');
            onDeleteModalClose();
          } else {
            handleError(error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [itemDelete, handleSuccess, onDeleteModalClose, handleError]
  );

  return {
    onRemoveConfirm,
    isLoading,
  };
};
